import React, { useEffect, useMemo, useState } from 'react'
import "./style.scss"
import FeatureSlider, { Slide } from 'Components/Common/FeatureSlider/FeatureSlider'
import findCreatorsImg from "../../assets/images/dashboard/slider/find-creators.jpg"
import competitorTrackingImg from "../../assets/images/dashboard/slider/competitor-tracking.jpg"
import collabInsightsImg from "../../assets/images/dashboard/slider/collab-insights.jpg"
import RecentCollabs from 'Components/dashboard/RecentCollabs'
import CompetitorAnalysisPreview from 'Components/dashboard/CompetitorAnalysisPreview'
import CompetitionContentPreview from 'Components/dashboard/CompetitionContentPreview'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import Loader from 'Components/Common/Loader'
import { fetchDashboardFeaturesThunk } from 'slices/dashboard/thunk'
import FeaturesIntroducer from 'Components/dashboard/FeaturesIntroducer'
import useDocumentTitle from 'hooks/useDocumentTitle'

export const featureSlides: Slide[] = [
    {
        id: 1,
        title: "Find right creators",
        description: "Diverse range of nano and micro creator for your brand",
        image: findCreatorsImg,
    },
    {
        id: 2,
        title: 'Track your competitors',
        description: "Know what your competitors are doing, who they work with, and what they post.",
        image: competitorTrackingImg
    },
    {
        id: 3,
        title: 'Track All Your Branded Collabs Content in One Place',
        description: "Add brand content to campaigns even outside Influns and replace WhatsApp and Excel.",
        image: collabInsightsImg
    }
]

const Dashbaord = () => {
    useDocumentTitle("Dashboard")
    const dashboardFeaturesData = useSelector((state: RootState) => state.dashboard.features);
    const features = dashboardFeaturesData?.items;
    const [loading, setLoading] = useState(false);
    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        setLoading(true)
        dispatch(fetchDashboardFeaturesThunk({})).finally(() => setLoading(false));
    }, [])

    const featureList = useMemo(() => {
        if (!features) return [];

        return Object.entries(features).map(([key, value]) => ({
            key,
            ...value,
        }));
    }, [features]);

    const completedCount = featureList.filter(f => f.status).length;

    return (
        <div className='position-relative mb-5 pb-5'>
            <div className="dashboard-hero">
                <div className="dashboard-header">
                    <h3 className='dashboard-heading'>Welcome to influns</h3>
                    <span className='dashboard-subheading'>Manage creator campaigns, track performance, and grow your brand all in one place.</span>
                </div>

            </div>
            <div className="dashboard-content">
                <div className="dashboard-feature-slider">
                    <div className="grid-bg"></div>
                    <FeatureSlider slides={featureSlides} />
                </div>
                {
                    (completedCount ?? 0) < (featureList ?? []).length &&
                    <div className="mt-5">
                        <FeaturesIntroducer features={features} loading={loading} />
                    </div>
                }
                {
                    loading ? (<Loader />) : (
                        <>
                            {
                                features?.collabs?.status &&
                                <div className="mt-5">
                                    <RecentCollabs />
                                </div>
                            }
                            {
                                features?.competitor?.status &&
                                <>
                                    {
                                        features?.competitor?.uuid &&
                                        <div className="mt-5">
                                            <CompetitorAnalysisPreview reportId={features?.competitor?.uuid} />
                                        </div>
                                    }
                                    <div className="mt-5">
                                        <CompetitionContentPreview />
                                    </div>
                                </>
                            }
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default Dashbaord 